import React, { useState } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import headerImage from "../../../../../assets/img/longarrow.jpg";
import GradientButton from "components/Buttons/GradientButton.js";
import ReusableInput from "components/Inputs/ReusableInput.js";

const FAQ_CATEGORIES = [
  { label: "Driver FAQ", value: "Driver FAQ" },
  { label: "Agent FAQ", value: "Agent FAQ" },
  { label: "Driver Partner", value: "Driver Partner" },
  { label: "General", value: "General" },
];

const AddFAQDrawer = ({ isOpen, onClose, onAddFAQ }) => {
  const [formData, setFormData] = useState({
    question: "",
    answer: "",
    category: "",
    dateAdded: new Date().toLocaleDateString(),
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    onAddFAQ(formData);
    onClose();
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerImage={headerImage}
      headerContent={<h2>Add New FAQ</h2>}
      bodyContent={
        <Stack spacing={4}>
          {/* Question */}
          <ReusableInput
            label="Question"
            name="question"
            value={formData.question}
            onChange={handleInputChange}
            placeholder="Enter the FAQ question"
            type="textarea"
          />

          {/* Category (ReusableInput Select) */}
          <ReusableInput
            label="Category"
            name="category"
            value={formData.category}
            onChange={handleInputChange}
            type="select"
            placeholder="Select FAQ category"
            options={FAQ_CATEGORIES}
          />

          {/* Answer */}
          <ReusableInput
            label="Answer"
            name="answer"
            value={formData.answer}
            onChange={handleInputChange}
            placeholder="Enter the FAQ answer"
            type="textarea"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton
            onClick={onClose}
            fontSize="15px"
            width="100px"
            height="40px"
          >
            Cancel
          </GradientButton>

          <GradientButton
            onClick={handleSubmit}
            fontSize="15px"
            width="100px"
            height="40px"
            isDisabled={
              !formData.question ||
              !formData.answer ||
              !formData.category
            }
          >
            Save
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default AddFAQDrawer;
